import { format } from "d3-format";
import { pipe } from "fp-ts/lib/pipeable";
import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { removeTrailingZero } from "../charts/lib/utils";
import { StackedBarAuto } from "../charts-motion";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_aid_fig_EDU_SCHOL_TT";
import { datasets } from "../data/data_finance_aid_fig_EDU_SCHOL_TT_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { An, io, O } from "../prelude";
export * from "../data/data_finance_aid_fig_EDU_SCHOL_TT";
const TypeOrder = {
    development: 0,
    humanitarian: 1
};
const Type = io.keyof(TypeOrder);
const typeLookup = {
    development: defineMessage({
        id: "fig.finance.aid.EDU_SCHOL_TT.development",
        defaultMessage: "Development"
    }),
    humanitarian: defineMessage({
        id: "fig.finance.aid.EDU_SCHOL_TT.humanitarian",
        defaultMessage: "Humanitarian"
    })
};
export const Data = mkGemDataDecoder([
    "year"
], {
    value: io.number,
    type: Type
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenLDown = !useMedia(breakpoints.l);
    const chartData = React.useMemo(()=>{
        return data.map((x)=>({
                ...x,
                type: intl.formatMessage(typeLookup[x.type])
            }));
    }, [
        intl,
        data
    ]);
    const getStack = React.useCallback((x)=>`${x.year}`, []);
    const getLayer = React.useCallback((x)=>x.type, []);
    const getLayerLabel = React.useCallback((x)=>x, []);
    const getValue = React.useCallback((x)=>x.value || 0, []);
    const formatX = React.useCallback((stack)=>stack, []);
    const formatY = React.useMemo(()=>removeTrailingZero(format(".1f")), []);
    const getColorPalette = React.useCallback((count)=>M.fromCount(M.colorRanges.sequential[0], count), []);
    return pipe(An.fromArray(chartData), O.map((xs)=><StackedBarAuto key={"linter-map"} height={screenLDown ? M.chartHeight.s : M.chartHeight.m} data={xs} getStack={getStack} getLayer={getLayer} getLayerLabel={getLayerLabel} getValue={getValue} formatX={formatX} formatY={formatY} yNice={6} colorPalette={getColorPalette} yUnitLabel={intl.formatMessage(defineMessage({
            id: "%",
            defaultMessage: "%"
        }))} showTooltip rotateXLabels/>), O.toNullable);
};
export default withFigureIO({
    url: new URL("../data/data_finance_aid_fig_EDU_SCHOL_TT.json", import.meta.url).href,
    csv: new URL("../data/data_finance_aid_fig_EDU_SCHOL_TT.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_aid_fig_EDU_SCHOL_TT.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    size: "main",
    datasets
});
